<rt-dialog-header [heading]="'app.offer_form_actions.edit_job_url.heading' | translate">
  <div class="subheading">
    {{ 'app.offer_form_actions.edit_job_url.subheading' | translate }}
    <a rtHelpArticle="editJobUrl">
      {{ 'app.common.learn_more' | translate }}
    </a>
  </div>
</rt-dialog-header>
<rt-dialog-body>
  <form [formGroup]="form" layout-vertical layout-full-width>
    <div class="input-container" layout>
      <div class="company-url-container">
        <rt-truncate [rtTooltip]="companyUrl">{{ companyUrl }}</rt-truncate>
      </div>
      <rt-form-field [hideRequiredBadge]="true" class="form-field">
        <rt-input
          [rtFormError]="errors"
          [maxLength]="255"
          variant="rounded"
          formControlName="offerSlug"
          (blur)="onBlurOfferSlugField()"
        ></rt-input>
      </rt-form-field>
    </div>
  </form>
</rt-dialog-body>
<rt-dialog-footer [innerPadding]="'small'">
  <rt-button variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button
    variant="primary"
    [disabled]="form.controls.offerSlug.invalid"
    [loading]="loading"
    (click)="save()"
  >
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
